import { iapConfirmErrors, sharedConfirmErrors } from "./confirmErrors.mjs";
import { confirmAppleInputSchema, confirmGoogleInputSchema, confirmResponseSchema, confirmWebInputSchema, getExtraPackageSkuInputSchema, listExtraPackageGroupsInputSchema, listExtraPackageSkusInputSchema, purchaseInputSchema, purchaseResultSchema, userExtraPackageGroupSchema, userExtraPackageSkuSchema } from "./schemas.mjs";
import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/payment/extraPackage/index.ts
const confirmRouter = oc.router({
	web: oc.route({
		method: "POST",
		path: "/confirm/web",
		summary: "Confirm extra-package payment for web providers"
	}).input(confirmWebInputSchema).output(confirmResponseSchema).errors(sharedConfirmErrors),
	apple: oc.route({
		method: "POST",
		path: "/confirm/apple",
		summary: "Confirm extra-package payment for Apple IAP"
	}).input(confirmAppleInputSchema).output(confirmResponseSchema).errors({
		...sharedConfirmErrors,
		...iapConfirmErrors
	}),
	google: oc.route({
		method: "POST",
		path: "/confirm/google",
		summary: "Confirm extra-package payment for Google IAP"
	}).input(confirmGoogleInputSchema).output(confirmResponseSchema).errors({
		...sharedConfirmErrors,
		...iapConfirmErrors
	})
});
const extraPackageContract = oc.prefix("/payment/extra-package").tag("ExtraPackage").router({
	list: oc.route({
		method: "GET",
		path: "/",
		summary: "List purchasable extra-package SKUs for the caller"
	}).input(listExtraPackageSkusInputSchema).output(z.object({ data: z.array(userExtraPackageSkuSchema) })),
	get: oc.route({
		method: "GET",
		path: "/{skuId}",
		summary: "Get a single extra-package SKU"
	}).input(getExtraPackageSkuInputSchema).output(z.object({ data: userExtraPackageSkuSchema })).errors({ SKU_NOT_FOUND: {
		status: 404,
		message: "Extra-package SKU not found"
	} }),
	purchase: oc.route({
		method: "POST",
		path: "/purchase",
		summary: "Create an order + dispatch payment for an extra-package SKU"
	}).input(purchaseInputSchema).output(purchaseResultSchema).errors({
		SKU_NOT_FOUND: {
			status: 404,
			message: "Extra-package SKU not found"
		},
		SKU_NOT_ACTIVE: {
			status: 400,
			message: "SKU is not currently active"
		},
		PROVIDER_NOT_SUPPORTED: {
			status: 400,
			message: "Provider not supported for this SKU"
		},
		MISSING_APP_STORE_ID: {
			status: 400,
			message: "SKU is missing appStoreProductId for Apple purchase"
		},
		MISSING_GOOGLE_PLAY_ID: {
			status: 400,
			message: "SKU is missing googlePlayProductId for Google purchase"
		},
		SKU_ALREADY_PURCHASED: {
			status: 409,
			message: "One-time SKU already purchased"
		},
		MONTHLY_LIMIT_REACHED: {
			status: 409,
			message: "Monthly purchase limit reached"
		}
	}),
	confirm: confirmRouter,
	listGroups: oc.route({
		method: "GET",
		path: "/group",
		summary: "List active extra-package groups"
	}).input(listExtraPackageGroupsInputSchema).output(z.object({ data: z.array(userExtraPackageGroupSchema) }))
});
//#endregion
export { extraPackageContract };
